export const strings_fr = {
  lang: 'fr',
  fallbackTenant: '24heures',
  mapTitle: "Nombre d'habitants et d'habitantes par hectare",

  search: 'Chercher',
  activateMap: 'Activer la carte',
  deactivateMap: 'Désactiver la carte',
  noResults: 'Aucun résultat trouvé',
  noGeolocation: 'Localisation non autorisée.',
  squareTitle: "Nombre d'habitants et d'habitantes",
  compareA: <>vivent dans des zones où la densité est moins élevée.</>,
  compareB: <>vivent dans des zones où la densité est plus élevée (par km²).</>,
  histoTitle: 'Nombre de personnes selon la densité de population',
  histoLabelVert: ['Personnes', ' par km2'],
  histoLabelHori: 'Nombre de personnes',
  lessThanOne: 'Moins de 1',
  evaluationText: [
    '',
    "personnes vivent dans l'hectare sélectionné. Autour de cet hectare, à l'intérieur d'un kilomètre carré , il y en a",
    ', en Suisse',
    'habitent encore plus densément.',
    '',
    '',
  ],
}
